import { trackEvent } from "@/lib/analytics";
import heroImg from "@/assets/cc_main_hero.png";
import logoUrl from "@/assets/clutchcube-logo.png";
import { Link } from "@tanstack/react-router";

export function Closing() {
  return (
    <section className="relative py-40 overflow-hidden">
      <img src={heroImg} alt="" aria-hidden width={1920} height={1280} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/85 to-background" />
      <div className="absolute inset-0 led-grid opacity-30" />
      <div className="relative mx-auto max-w-5xl px-6 text-center">
        <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.95]">
          Every fan has imagined the moment. <br />
          <span className="text-gradient-ember">ClutchCube lets them live it.</span>
        </h2>
        <p className="mt-8 font-display text-xl sm:text-2xl text-muted-foreground max-w-3xl mx-auto leading-snug">
          The next generation of sports entertainment will not be watched.{" "}
          <span className="text-foreground">It will be lived.</span>
        </p>
        <div className="mt-12">
          <a
            href="#invest"
            onClick={() => trackEvent("investor_cta_click", { placement: "closing" })}
            className="inline-flex items-center justify-center px-10 py-5 bg-primary text-primary-foreground font-semibold uppercase tracking-widest text-sm rounded-sm shadow-glow hover:translate-y-[-2px] transition"
          >
            Request Investor Deck
          </a>
        </div>
      </div>
    </section>
  );
}

type FooterLink = { label: string; href: string; external?: boolean; to?: string };

const footerLinks: FooterLink[] = [
  { label: "Contact", href: "/#invest", external: true },
  { label: "Customer Support", href: "/support", to: "/support" },
  { label: "Investor Relations", href: "/#invest", external: true },
  { label: "Partnerships & Sponsorships", href: "/partnerships", to: "/partnerships" },
  { label: "Media Center", href: "/media", to: "/media" },
  { label: "Privacy Policy", href: "/privacy", to: "/privacy" },
  { label: "Terms of Use", href: "/terms", to: "/terms" },
  { label: "Investor Disclaimer", href: "/investor-disclaimer", to: "/investor-disclaimer" },
];

export function Footer() {
  return (
    <footer className="border-t border-border py-12">
      <div className="mx-auto max-w-7xl px-6 flex flex-col gap-8">
        <div className="flex flex-wrap items-center justify-between gap-6">
          <div className="flex items-center">
            <img src={logoUrl} alt="ClutchCube" className="h-7 w-auto" />
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-[0.25em] text-muted-foreground">
            {footerLinks.map((l) =>
              l.to ? (
                <Link key={l.label} to={l.to} className="hover:text-foreground transition">
                  {l.label}
                </Link>
              ) : (
                <a key={l.label} href={l.href} className="hover:text-foreground transition">
                  {l.label}
                </a>
              )
            )}
          </nav>
        </div>
        <div className="flex flex-col gap-3 text-[11px] uppercase tracking-[0.25em] text-muted-foreground border-t border-border/60 pt-6">
          <p>© 2026 ClutchCube. All rights reserved.</p>
          <p className="normal-case tracking-normal text-xs leading-relaxed">
            ClutchCube is operated by{" "}
            <a href="https://www.colowebo.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition underline-offset-4 hover:underline">
              Colowebo LLC
            </a>{" "}
            as part of the{" "}
            <a href="https://www.venturexos.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition underline-offset-4 hover:underline">
              VentureX OS
            </a>{" "}
            venture ecosystem.
          </p>
          <div className="flex flex-wrap items-center justify-between gap-4">
            <p>Built for the Experience Economy</p>
            <p className="flex gap-4">
              <Link to="/privacy" className="hover:text-foreground transition">Privacy Policy</Link>
              <span aria-hidden>|</span>
              <Link to="/terms" className="hover:text-foreground transition">Terms of Service</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
